import { AI_SUGGESTION_TRIGGERED_FROM } from '@atlaskit/editor-common/analytics';
import type { ExtractInjectionAPI, Command } from '@atlaskit/editor-common/types';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';

import type { AIPlugin } from '../../aiPluginType';

import {
	clearSuggestionWithAnalytics,
	insertInlineSuggestionWithAnalytics,
	fireNewSuggestionAnalytics,
} from './commands/commands-with-analytics';
import { getPluginState as getInlineSuggestionState } from './plugin-factory';

export function docHasChanged(prevState: EditorState, newState: EditorState): boolean {
	return !prevState.doc.eq(newState.doc);
}

export function localeHasChanged(state: EditorState, currentLocale: string): boolean {
	return getInlineSuggestionState(state).locale !== currentLocale;
}

export enum KeydownActionType {
	INSERT = 'INSERT',
	DISMISS = 'DISMISS',
}

export const createKeyHander = (
	actionType: KeydownActionType,
	triggeredFrom: AI_SUGGESTION_TRIGGERED_FROM,
	api?: ExtractInjectionAPI<AIPlugin>,
): Command => {
	return (state, dispatch) => {
		if (getInlineSuggestionState(state).inlineSuggestion) {
			if (actionType === KeydownActionType.INSERT) {
				insertInlineSuggestionWithAnalytics(api?.analytics?.actions)(triggeredFrom)(
					state,
					dispatch,
				);
				return true;
			}

			if (actionType === KeydownActionType.DISMISS) {
				clearSuggestionWithAnalytics(api?.analytics?.actions)(triggeredFrom)(state, dispatch);
				return true;
			}
		}
		return false;
	};
};

export const fireAnalyticsForNewInlineSuggestionShown = (
	oldState: EditorState,
	newState: EditorState,
	api?: ExtractInjectionAPI<AIPlugin>,
) => {
	const { inlineSuggestion: oldInlineSuggestions } = getInlineSuggestionState(oldState);
	const { inlineSuggestion: newInlineSuggestions } = getInlineSuggestionState(newState);

	if (
		oldInlineSuggestions?.metadata !== newInlineSuggestions?.metadata &&
		newInlineSuggestions !== null
	) {
		fireNewSuggestionAnalytics({
			analyticsApi: api?.analytics?.actions,
			state: newState,
		});
	}
	return null;
};
